import React from "react";
import {Input} from "reactstrap";
import Icons from "../Icons";
import {getRequestConfig, request} from "tunnel-commande/src/utils";
import { removeFileInLocaleStorage, getFileInLocaleStorage } from '../RenderDT';
import {withTranslation} from "react-i18next";
import Modal from 'react-responsive-modal';
import {DimensionsForm} from "./DimensionsForm";
import {withHostApi} from "../../contexts/HostApiContext";
import ProgressUpload from "../Product/ProgressUpload";
import { getShopInfosInStorage } from "tunnel-commande/src/components/cart/ShopInfos";
import {CanUpdateDimensions} from "./DimensionsForm";

interface UploadInputState {
  miniature?: string | null;
  creationId?: string | null;
  transferType?: string | null;
  nameFile?: string | null;
  poids?: number | null;
  errors?: number | null;
  loading: boolean;
  openZoom: boolean;
  openTooltip: boolean;
  openPopover: boolean;
  largeur?: number | null;
  hauteur?: number | null;
  ratio?: number;
  authorizedFilesExtensions?: string
  percentLoad: number;
  dimensionsUpdated?: boolean;
  fichierSrc?: string;
  canUpdateDimensions?: CanUpdateDimensions;
  dataFile?: File;
}

class UploadInput extends React.Component<any, UploadInputState> {
  private interval: any;
  constructor(props: any) {
    super(props);
    this.state = {
      loading: false,
      openZoom: false,
      openTooltip: false,
      openPopover: false,
      percentLoad: 0
    };
    this.interval = null;
    this.handleOnFormChange = this.handleOnFormChange.bind(this);
    this.onDeleteFile = this.onDeleteFile.bind(this);
    this.handleImageErrored = this.handleImageErrored.bind(this);
    this.setTooltipOpen = this.setTooltipOpen.bind(this);
    this.setPopoverOpen = this.setPopoverOpen.bind(this);
    this.pageClick = this.pageClick.bind(this);
  }

  componentDidMount(): void {
    this.getFileInLocaleStorage();
    this.getAuthorizedFilesExtension();
    window.addEventListener("click", this.pageClick, false);
  }

  componentWillUnmount(): void {
    window.removeEventListener("click", this.pageClick);
  }

  private pageClick(e: any) {
    const elt = e.path;
    if(elt && this.state.openPopover) {
      let isPopover = false;
      elt.forEach(function(item: any){
        if (item && item.classList && item.classList.contains('popover')) {
          isPopover = true;
        }
      });
      if(!isPopover) {
        this.setPopoverOpen();
      }
    }
  }

  private handleOnFormChange(e: any) {
    this.uploadFile(e);
  }
  private handleImageErrored(){
    if(this.state.creationId) {
      this.onDeleteFile();
    }
  }

  private setTooltipOpen() {
     this.setState({openTooltip: !this.state.openTooltip});
  }

  private setPopoverOpen() {
    this.setState({openPopover: !this.state.openPopover});
  }

  private getFileInLocaleStorage() {
    const files = getFileInLocaleStorage();
    if(files && Object.keys(files).length > 0) {
      this.props.onUploadLoading(true);
      const valuesFilesSameType = (Object.values(files) as any).filter((element: { transfertType: string; }) => element.transfertType === this.props.transferType);
      if(valuesFilesSameType.length > 0) {
        const lastFiles = valuesFilesSameType[0].creationId;
        const sameTransfertType = this.props.transferType === files[lastFiles].transfertType;
        const fileIsExpired = new Date() > new Date(files[lastFiles].expirationDate);
        if(!fileIsExpired) {
          if(sameTransfertType) {
            this.setFile(files[lastFiles], false);
          }
        }
      }
    }
  }

  private setFile(params: any, save: boolean = true) {
    this.props.setDimensions(params.dimensionsCM.largeur, params.dimensionsCM.hauteur);
    this.setState({
      miniature: params.miniature,
      creationId: params.creationId,
      nameFile: params.name,
      poids: params.poids,
      errors: null,
      loading: false,
      largeur: params.dimensionsCM.largeur,
      hauteur: params.dimensionsCM.hauteur,
      ratio: params.dimensionsCM.ratio,
      transferType: this.props.transferType,
      canUpdateDimensions: params.canUpdateDimensions,
      fichierSrc: params.fichierSrc,
      dataFile: params.dataFile,
      hasAlphaChannel: params.hasAlphaChannel
    }, () => {
      this.props.onUpload(params.name, params.creationId);
      this.props.onUploadLoading(false);
      this.props.getFileInfos(params);
      if(save) {
        this.addFileInLocaleStorage(params.miniature, params.creationId, params.name, params.poids, params.dimensionsCM.largeur, params.dimensionsCM.hauteur, params?.finesse, params?.UniversalImageToTiff, this.props?.transferType, params?.canUpdateDimensions, params?.fichierSrc, params?.dimensionsCM.ratio, params?.hasAlphaChannel);
      }
    });
  }

  private addFileInLocaleStorage(miniature: string, creationId: string, name: string, poids: number, largeur: number, hauteur: number, finesse: string | null, UniversalImageToTiff: boolean | null,  transfertType: string | null, canUpdateDimensions: CanUpdateDimensions, fichierSrc: string, ratio: number | null, hasAlphaChannel: boolean) {
    if (localStorage) {
        const visuelsPresents = localStorage['filesStorage'] ? JSON.parse(localStorage['filesStorage']) : {};
        const visuelNouveau: Record<string, any> = {};
        const now = new Date();
        const dureeViePanier = (getShopInfosInStorage() ?  getShopInfosInStorage().duree_vie_panier : 30) + 2;
        now.setDate(now.getDate() + dureeViePanier);
        visuelNouveau[creationId] = {
          "miniature": miniature,
          "creationId": creationId,
          "name": name,
          "poids": poids,
          "finesse": finesse,
          "UniversalImageToTiff": UniversalImageToTiff,
          "transfertType": transfertType,
          "hasAlphaChannel": hasAlphaChannel,
          "dimensionsCM" : {
            "largeur": largeur,
            "hauteur": hauteur,
            "ratio": ratio
          },
          "expirationDate": now,
          "canUpdateDimensions": canUpdateDimensions,
          "fichierSrc": fichierSrc
        };
        const ensemble = {...visuelsPresents, ...visuelNouveau};
        localStorage.setItem('filesStorage', JSON.stringify(ensemble));
      }
  }

  private getAuthorizedFilesExtension = (): any => {
    request("GET", `${this.props.hostApi}/file/authorized-file-extensions`, {
      ...getRequestConfig()
    }).then((res) => {
      this.setState({
        authorizedFilesExtensions: res.data.authorized_files.join(',')
      })
    }).catch((error) => {
      console.log(error);
    });
  };

  private uploadFile(e: any) {
    const isReupload = (this.props.isDejaUpload && this.state.poids && this.state.nameFile) !== null;
    if(isReupload || !(this.state.largeur && this.state.hauteur && this.state.dimensionsUpdated)) {
      this.onDeleteFile();
    }
    this.props.onUploadLoading(true);
    this.setState({loading: true, errors: null, percentLoad: 0});
    const formData = new FormData();
    if (e.target?.files[0] || this.state.dataFile && !this.state.dimensionsUpdated) {
      formData.append("file", e.target?.files[0] ?? this.state.dataFile);
    } else {
      const jsondata = JSON.parse(localStorage['filesStorage']);
      formData.append("file", (Object.values(jsondata) as any).filter((element: { transfertType: string; }) => element.transfertType === this.props.transferType)[0].fichierSrc);
      formData.append("isModifDim", "true");
    }

    formData.append("articleId", this.props.articleId);

    if(this.state.largeur && this.state.hauteur && this.state.dimensionsUpdated) {
      formData.append('s', this.state.largeur + 'x' + this.state.hauteur);
    }

    request("POST", `${this.props.hostApi}/file/valid`, {
      ...getRequestConfig(),
      data: formData,
      onUploadProgress: this.onUploadProgress
    }).then((res) => {
      const json = res.data;
      json.dataFile = e.target?.files[0] ?? this.state.dataFile;
      if(json && json.dimensionsCM && json.dimensionsCM.largeur && json.dimensionsCM.hauteur ) {
        this.setFile(json);
      } else {
        this.setState({
          errors: json.message,
          miniature: null,
          creationId: null,
          poids: null,
          nameFile: null,
          loading: false,
          openZoom: false,
          openTooltip: false,
          openPopover: false,
          dimensionsUpdated: false,
          dataFile: undefined
        });
      }
    }).catch((err) => {
      const json = err.response?.data;

      if(json) {
        this.setState({
          errors: json.message,
          miniature: null,
          creationId: null,
          poids: null,
          nameFile: null,
          loading: false,
          openZoom: false,
          openTooltip: false,
          openPopover: false,
          dimensionsUpdated: false,
          dataFile: undefined
        });
      }
    }).finally(() => {
      this.props.onUploadLoading(false);
      clearInterval(this.interval);
    });
  }

  private onDeleteFile() {
    const creationId = this.state.creationId;
    if(creationId && creationId !== null) {
      request("POST", `${this.props.hostApi}/file/remove`, {
        ...getRequestConfig(),
        method: 'POST',
        data: {creationId: creationId}
      }).then(() => {
        this.props.onDelete?.();
        this.setState({
          errors: null,
          miniature: null,
          creationId: null,
          poids: null,
          nameFile: null,
          openZoom: false,
          openTooltip: false,
          openPopover: false,
          dimensionsUpdated: false,
          dataFile: undefined
        }, () => {
          removeFileInLocaleStorage(creationId);
        });
      }).catch((err) => {
        console.error(err);
      });
    }
  }

  onOpenModalZoom = () => {
    if (!this.state.openZoom) { this.setState({openZoom: true}); }
  }

  onCloseModalZoom = () => {
    if (this.state.openZoom) { this.setState({openZoom: false}); }
  }

  onUploadProgress = (event: ProgressEvent) => {
    this.setState({percentLoad: ((event.loaded / event.total) * 100) / 2});
    if (event.loaded === event.total) {
      let percent = 50;
      this.interval = setInterval(() => {
        percent += 1;
        this.setState({percentLoad: percent});
        if (percent === 97) {
          clearInterval(this.interval);
        }
      }, (50 * 1000) / 47); // calculé l'intervalle d'incrémentation sur 50s pour 49%
    }
  }

  handleDeleteImg = () => {
    this.onDeleteFile();
  }

  setDimensions = (largeur: number, hauteur: number) => {
    this.props.onUploadLoading(true);
    this.setState({
      largeur,
      hauteur,
      dimensionsUpdated: true
    }, () => {
      this.uploadFile("");
    });
  }

  render() {

    const renderInputFile = () => {
      return (
        <>
          <div className={`form-group position-relative file-custom font22 ${this.props.isDejaUpload && this.state.poids && this.state.nameFile && !this.state.loading ? 'file-custom-reupload my-3' : '' }`}>
            {!this.state.loading && (
              <Input id={"input_file"} onChange={e => this.handleOnFormChange(e)} name={"file"}  className={'input-file '} type={"file"} accept={this.state.authorizedFilesExtensions}  />
            )}
            <p className={'p-1'}>
              {this.state.loading && (
                <ProgressUpload percent={this.state.percentLoad} t={this.props.t} />
              ) || (
                <>
                  <Icons icon="ic-upload" size={this.props.isDejaUpload && this.state.poids && this.state.nameFile ? 25 : 35 } className={'mr-2'}/>
                  <span className={'labelInputUpload'}>
                    {this.props.isDejaUpload && this.state.poids && this.state.nameFile ? (
                        this.props.t('reupload')
                      ) : (
                      this.props.t('upload_file')
                      )}
                  </span>
                </>
              )}
            </p>
          </div>
        </>
      )};

    if(this.props.isDejaUpload && this.state.poids && this.state.nameFile && !this.state.loading) {
      return (
        <div className={'d-block d-lg-flex flex-wrap'}>
          <div className={'d-flex justify-content-center  justify-content-lg-start flex-grow-1 flex-grow-lg-0'}>
            {this.state.miniature &&
            <div className={' p-2 border bg-alpha d-flex position-relative customerUploadContainer'}>
              <Icons
                className="bg-black p-1 position-absolute cursor-pointer"
                icon="delete"
                style={{bottom: 0, right: 0}}
                size={24}
                fill="#FFFFFF"
                onClick={this.handleDeleteImg}
              />
              <img onError={this.handleImageErrored} onClick={this.onOpenModalZoom} className={'img-fluid img-upload-miniature align-self-center cursor-zoom'} src={`${this.props.hostApi}${this.state.miniature}`}/>
              <Modal open={this.state.openZoom} onClose={this.onCloseModalZoom} classNames={{modal: "zoomModalContainer"}} center>
                <div className={'p-3'}>
                  <div className="bg-alpha">
                    <img src={`${this.props.hostApi}${this.state.miniature}`} alt="" className="img-fluid"/>
                  </div>
                </div>
              </Modal>
            </div>
            }
          </div>
          {this.state.largeur && this.state.hauteur &&
            <DimensionsForm height={this.state.hauteur} width={this.state.largeur} surfaceMin={this.props.surfaceDefault}
              surface={Math.round(this.state.largeur * this.state.hauteur * 100) / 100} traduction={this.props.t}
              onSendDimensions={this.setDimensions} canUpdateDimensions={this.state.canUpdateDimensions} ratio={this.state.ratio}
              onUpdate={(isModified) => this.props.onDimensionsChange(isModified)}
            />
          }
          {!this.state.hasAlphaChannel  &&
            <div className={'text-center alert alert-warning mt-3 w-100 text-center'}>
              <Icons icon={'warning'} size={20} fill={"orange"} className="mr-1" />{this.props.t('alpha_warning_1')}
              <div className={'font14 italic'}>  {this.props.t('alpha_warning_2')}</div>
            </div>
          }
        </div>
      );
    }


    const renderErrors = () => {
      const lstErrors: any[] = [];
      if(Array.isArray(this.state.errors)) {
        this.state.errors.forEach((message) => {
          lstErrors.push(<li>{message}</li>);
        });
        return lstErrors;
      } else {
        return <p>{this.state.errors}</p>;
      }
    };

    return (
      <>
        {renderInputFile()}
        {this.state.errors &&
          <>
          <div className={'red  mt-3'}>{this.props.t('problem_with_file')} : </div>
          <div className={'red bold pt-2 pl0 border-danger'}>
            {this.state.errors && renderErrors()}
          </div>
          </>
        }
      </>
    );
  }
}
export default withTranslation('common')(withHostApi(UploadInput));
